import React, { type FC } from 'react';
import { DH } from '../../../../utils/dataHooks';
import { type PaymentsButtonPlace } from '../../../../types/PaymentsButtonViewConfig';
import { type PaymentMethodConfig } from '../../buttonsViewConfig';
import { PaymentButton } from './PaymentButton';
import { st, classes } from './styles.st.css';

type ExpressButtonsProps = {
  vertical?: boolean;
  items: PaymentMethodConfig[];
  place: PaymentsButtonPlace;
  dataHook?: string;
  className?: string;
};

export const ExpressButtons: FC<ExpressButtonsProps> = ({ items, place, vertical, dataHook, className }) => (
  <div className={st(classes.root, { vertical }, className)} data-hook={dataHook}>
    {items.map((item) => (
      <div key={item.name} className={st(classes.gridItem)} data-hook={DH.Widget.PMListItem(item.name)}>
        <PaymentButton name={item.name} place={place} />
      </div>
    ))}
  </div>
);
